import { Action, ActionReducer } from '@ngrx/store';

/**
 * Reducer manages loading status addition.
 */
export const loadingStatusAdd: ActionReducer<string[]> = (state: string[] = [], {payload}: StatusAction) => {
    return [...state, payload];
};

/**
 * Reducer manages loading status removal.
 */
export const loadingStatusRemove: ActionReducer<string[]> = (state: string[] = [], {payload}: StatusAction) => {
    return state.filter(s => s !== payload);
};

/**
 * Action represents change of loading status.
 *
 * Type is currently performed action - it is not used in reducers, see above. It is only used to be compatible with
 * Action interface.
 * Payload represents action that is used to represent loading status, for example loading applications.
 */
export class StatusAction implements Action {
    constructor(public type: string, public payload: string) {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/reducers/loading-status.reducer.ts